import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmationWithCheckConfig } from './confirm-with-check-dialog.types';

@Component({
    selector: 'confirmation-with-check-dialog',
    templateUrl: './confirm-with-check-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
            .confirmation-with-check-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationWithCheckDialogComponent {

    checked = this.data.check?.checked ?? false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationWithCheckConfig,
        public matDialogRef: MatDialogRef<ConfirmationWithCheckDialogComponent>
    ) { }

}
